class CrossSellForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (this.form) {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
    this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    this.submitButton = this.querySelector('[type="submit"]');
    this.hideErrors = this.dataset.hideErrors === 'true';
  }

  hideErrors() {
    this.hideErrors = true;
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript',
      },
    };

    const formData = new FormData(this.form);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status) {
          this.handleErrorMessage(parsedState.description);
          return;
        }

        // Toujours utiliser notre méthode de rafraîchissement personnalisée
        // car renderContents attend une structure spécifique que cart_add_url ne fournit pas
        setTimeout(() => {
          this.refreshCartDrawer();
        }, 500); // Attendre 500ms pour s'assurer que le serveur a traité l'ajout
      })
      .catch((error) => {
        console.error('Error:', error);
        // En cas d'erreur, essayer quand même de rafraîchir le panier
        this.refreshCartDrawer();
        this.handleErrorMessage();
      })
      .finally(() => {
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.querySelector('.loading__spinner').classList.add('hidden');
      });
  }

  handleErrorMessage(errorMessage = false) {
    if (errorMessage) {
      this.querySelector('.product-form__error-message').textContent = errorMessage;
    }
    this.querySelector('.product-form__error-message-wrapper').toggleAttribute('hidden', !errorMessage);
  }

  refreshCartDrawer() {
    // Forcer la mise à jour du cart-drawer en rechargeant son contenu
    if (this.cart) {
      // Utiliser directement notre méthode de rafraîchissement personnalisée
      // car elle est plus fiable et évite les conflits avec renderContents
      this.refreshCartItems();
    }
  }

  refreshCartItems() {
    // Recharger spécifiquement la zone des articles du panier
    console.log('Rafraîchissement des articles du panier...');
    
    fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        console.log('Réponse reçue, mise à jour du panier...');
        
        // Créer un DOM temporaire pour extraire le contenu
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        // Trouver la zone des articles dans le cart-drawer actuel
        const currentCartItems = this.cart.querySelector('.drawer__cart-items-wrapper');
        const newCartItems = tempDiv.querySelector('.drawer__cart-items-wrapper');
        
        console.log('Current cart items:', currentCartItems);
        console.log('New cart items:', newCartItems);
        
        if (currentCartItems && newCartItems) {
          // Sauvegarder l'ancien contenu en cas de problème
          const oldContent = currentCartItems.innerHTML;
          
          try {
            // Mettre à jour le contenu des articles
            currentCartItems.innerHTML = newCartItems.innerHTML;
            console.log('Contenu des articles mis à jour avec succès');
            
            // Mettre à jour aussi le total et autres éléments
            this.updateCartElements(tempDiv);
            
            // Mettre à jour le compteur d'articles dans l'icône du panier
            this.updateCartIcon();
            
          } catch (error) {
            console.error('Erreur lors de la mise à jour du contenu:', error);
            // Restaurer l'ancien contenu en cas d'erreur
            currentCartItems.innerHTML = oldContent;
          }
        } else {
          console.warn('Impossible de trouver les zones de cart items');
          if (!currentCartItems) console.warn('Zone actuelle non trouvée');
          if (!newCartItems) console.warn('Nouvelle zone non trouvée');
        }
      })
      .catch(error => {
        console.error('Erreur lors du rafraîchissement des articles du panier:', error);
      });
  }

  updateCartElements(tempDiv) {
    // Mettre à jour le total du panier
    const currentTotals = this.cart.querySelector('.totals__total-value');
    const newTotals = tempDiv.querySelector('.totals__total-value');
    if (currentTotals && newTotals) {
      currentTotals.innerHTML = newTotals.innerHTML;
      console.log('Total mis à jour');
    }
    
    // Mettre à jour le compteur d'articles dans le titre
    const currentItemCount = this.cart.querySelector('.drawer__heading span');
    const newItemCount = tempDiv.querySelector('.drawer__heading span');
    if (currentItemCount && newItemCount) {
      currentItemCount.innerHTML = newItemCount.innerHTML;
      console.log('Compteur d\'articles mis à jour');
    }
    
    // Mettre à jour la classe is-empty si nécessaire
    const cartItems = this.cart.querySelector('cart-drawer-items');
    if (cartItems) {
      const isEmpty = tempDiv.querySelector('cart-drawer-items.is-empty');
      if (isEmpty) {
        cartItems.classList.add('is-empty');
      } else {
        cartItems.classList.remove('is-empty');
      }
      console.log('Classe is-empty mise à jour');
    }
  }

  updateCartIcon() {
    // Mettre à jour l'icône du panier
    fetch(`${window.Shopify.routes.root}cart?section_id=cart-icon-bubble`)
      .then(response => response.text())
      .then(html => {
        const cartIcon = document.querySelector('#cart-icon-bubble');
        if (cartIcon) {
          cartIcon.innerHTML = html;
          console.log('Icône du panier mise à jour');
        }
      })
      .catch(error => {
        console.error('Erreur lors de la mise à jour de l\'icône du panier:', error);
      });
  }
}

customElements.define('cross-sell-form', CrossSellForm);
